/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import styles from '../styles/tooltip.module.scss';

const Tooltip = ({
  children: originalChildren,
  placement = 'top',
  className = '',
  content,
  delay = [200, 0],
  duration = [100, 0],
  zIndex = 9999,
  ...rest
}) => {
  let children = originalChildren;

  if (!content || !children) return null;

  if (React.isValidElement(children)) {
    children = React.cloneElement(children, {
      className: classnames(children.props.className, styles.children),
    });
  }

  return (
    <Tippy
      maxWidth={1024}
      className={classnames(styles.element, className)}
      content={content}
      arrow
      animation="fade"
      duration={duration}
      delay={delay}
      placement={placement}
      touch={false}
      zIndex={zIndex}
      {...rest}
    >
      {children}
    </Tippy>
  );
};

Tooltip.propTypes = {
  children: PropTypes.element.isRequired,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]).isRequired,
  delay: PropTypes.arrayOf(PropTypes.number),
  duration: PropTypes.arrayOf(PropTypes.number),
  zIndex: PropTypes.number,
};

export { Tooltip as TooltipStorybook };
export default React.memo(Tooltip);
